import { createFileRoute, useRouter } from '@tanstack/react-router';
import TimesheetList from 'containers/Timesheets/TimesheetList';
import { timesheetEmployeePath } from 'containers/Timesheets/timesheetListFilters';
import {
  resolveTimesheetRange,
  validateTimesheetSearch,
  type TimesheetRange,
} from 'containers/Timesheets/timesheetRange';

export const Route = createFileRoute('/_authenticated/timesheets/')({
  validateSearch: validateTimesheetSearch,
  component: TimesheetsPage,
});

function TimesheetsPage() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const router = useRouter();
  const range = resolveTimesheetRange(search);

  const handleRangeChange = (next: TimesheetRange) => {
    navigate({ search: next });
  };

  return (
    <TimesheetList
      range={range}
      onRangeChange={handleRangeChange}
      onOpenEmployee={(empID) => router.history.push(timesheetEmployeePath(empID, range))}
    />
  );
}
